import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    queue: [],
    lastId: 0
  },
  actions: {
    async add ({state, commit, dispatch, getters}, {url, query}) {
      const queueId = state.lastId + 1
      const ts = new Date().getTime()
      commit('INCREMENT', queueId)
      commit('ADD_TO_QUEUE', {url, query, queueId, ts})
      // console.log('>> QUEUE', queueId)
      return queueId
    },
    async find ({state}, {url, query}) {
      return state.queue.find(qObj => qObj.url === url && qObj.query === query)
    },
    async remove ({state, commit}, queueId) {
      const index = state.queue.findIndex(({id}) => id === queueId)
      if (index !== -1) {
        commit('REMOVE_FROM_QUEUE', index)
        return true
      }
      return false
    }
  },
  mutations: {
    INCREMENT: (state, value) => {
      Vue.set(state, 'lastId', value)
    },
    ADD_TO_QUEUE: (state, {ts, url, query, queueId}) => {
      state.queue.push({ts, url, query, id: queueId})
    },
    REMOVE_FROM_QUEUE: (state, index) => {
      Vue.delete(state.queue, index)
    }
  },
  getters: {
    loading: (state) => state.queue.length >= 0
  }
}
